import React from "react";
import styles from "./DialogContent.module.css";

export interface DialogContentProps {
  children: React.ReactNode;
  padding?: boolean;
  className?: string;
}

export const DialogContent: React.FC<DialogContentProps> = ({
  children,
  padding = true,
  className,
}) => {
  return (
    <div
      className={`${styles.Content} ${padding ? styles.WithPadding : ""} ${
        className || ""
      }`}
    >
      {children}
    </div>
  );
};
